import React from 'react';
import {Button} from 'antd';

import {openSignup, useIsMobile} from '../../utils/helpers';
import {trackEvent} from '../../analytics/posthog';

const HeroSection: React.FC = () => {

    const isMobile = useIsMobile();

    const scrollToHowItWorks = () => {
        trackEvent('landing_hero_how_it_works_clicked');
        document.getElementById('how-it-works')?.scrollIntoView({behavior: 'smooth'});
    };

    return (
        <section className="pt-20 pb-0 overflow-hidden relative z-10">
            <div className="container px-6 grid lg:grid-cols-7 gap-16 items-center">
                <div className="lg:col-span-3 text-center sm:text-start">
                    <h1 className="text-5xl font-semibold mb-6 leading-tight">
                        Power your clicks
                        <br/>
                        {isMobile
                            ? 'with transparent, organic advertising'
                            : 'with transparent, organic\u00A0advertising'}
                    </h1>
                    <p className="text-[#1677ff] mb-6">
                        Advertisers, Promoters and Partners all collaborate in one open marketplace—no hidden fees, full
                        control.
                    </p>
                    <div className="flex gap-4 justify-center sm:justify-start">
                        <Button
                            type="primary"
                            size="large"
                            onClick={() => {
                                trackEvent('landing_hero_get_started_clicked', {
                                    signup_source: 'landing_hero_get_started'
                                });
                                openSignup(undefined, 'landing_hero_get_started');
                            }}
                        >
                            Get started
                        </Button>
                        <Button size="large" onClick={scrollToHowItWorks}>How it works</Button>
                    </div>
                </div>
                <div className="lg:col-span-4">
                    <img
                        src="assets/images/hero/hero-v2.svg"
                        alt="Promotify dashboard"
                        className="w-full lg:w-[135%] max-w-none translate-y-18 lg:translate-y-18"
                    />
                </div>
            </div>
        </section>
    );
};

export default HeroSection;
